var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconRotateLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "-0.5 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 10.55L6 14.55L2 10.55",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.34 18.0801C9.64796 19.3895 11.3695 20.2047 13.2112 20.3872C15.053 20.5697 16.901 20.1081 18.4405 19.0808C19.98 18.0535 21.1157 16.5242 21.654 14.7534C22.1924 12.9827 22.1002 11.0802 21.3931 9.36988C20.686 7.65953 19.4077 6.24713 17.7761 5.37354C16.1445 4.49996 14.2605 4.21912 12.445 4.57887C10.6295 4.93861 8.99496 5.91668 7.81976 7.34645C6.64457 8.77621 6.00146 10.5692 6 12.4199V14.1499",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRotateLeft);
export default __webpack_public_path__ + "static/media/icon-rotate-left.de9f0ec1dac88e86eaeccc33e209aef1.svg";
export { ForwardRef as ReactComponent };